import { post } from "../api";
import {
  POST_SHARED_URL
} from "../utils/url";

export const createShared = (shared) => {
  return post(POST_SHARED_URL, shared);
}
